import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import img from 'assets/graphics/formComplete.png';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import analyticsService, { AmplitudeEventData, AnalyticsEvent } from 'services/AnalyticsService';
import { MuiBox } from 'theme/material-ui';
import { RegNotificationImg } from '../styled';
import { handleUrlOnComplete } from 'store/pageActions/RegisterAccount';

const RegisterSuccess = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  /* eslint-disable @typescript-eslint/camelcase */
  const redirect_index = window.localStorage.getItem('redirectIdx');
  const redirect_brand = window.localStorage.getItem('registerBrand');
  const eventData: AmplitudeEventData = {
    redirect_index,
    redirect_brand
  };

  useEffect(() => {
    analyticsService.logEvent(AnalyticsEvent.AccountCreationCompleted, eventData);
  }, []);

  return (
    <>
      <Box mb={3}>
        <MuiBox display="flex" alignItems="center" justifyContent="center">
          <RegNotificationImg src={img} alt="Account has been successfully created" />
        </MuiBox>
        <Box mb={1}>
          <Typography variant="h6">Account Created</Typography>
        </Box>
        <Typography variant="body1">
          Your account has been successfully created. Please continue to login.
        </Typography>
      </Box>
      <Button
        variant="contained"
        fullWidth
        color="primary"
        size="large"
        onClick={() => dispatch(handleUrlOnComplete(history))}
      >
        Continue to login
      </Button>
    </>
  );
};

export default RegisterSuccess;
